import { Component, computed } from '@angular/core';
import { NavigationError, Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToasterPositionEnum } from '@shared/enums';
import { ToastModule } from 'primeng/toast';
import { FooterComponent } from '@layout/components/footer/footer.component';
import { CurrentUserService } from '@core/services';
import { HeaderComponent } from '@layout/components/header/header.component';
import { LayoutService } from '@layout/core/services';
import { NgClass } from '@angular/common';
import { SidebarComponent } from '@layout/components/sidebar/sidebar.component';
import { MobileMenuComponent } from '@layout/components/mobile-menu/mobile-menu.component';
import { ImpersonationModalComponent } from '@layout/components/impersonation-modal/impersonation-modal.component';
import { BrowserStorageHelper } from '@core/helpers';
import { AccountInfoVerificationComponent } from '@shared/components/account-info-verification/account-info-verification.component';
import { filter, map } from 'rxjs';
import { MixpanelService } from '@shared/mixpanel';
import { LoaderComponent } from '@shared/components/loader/loader.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: true,
    imports: [
        RouterOutlet,
        HeaderComponent,
        TranslateModule,
        ToastModule,
        FooterComponent,
        HeaderComponent,
        NgClass,
        SidebarComponent,
        MobileMenuComponent,
        ImpersonationModalComponent,
        AccountInfoVerificationComponent,
        LoaderComponent,
    ],
})
export class AppComponent {
    isSidebarCollapsed: boolean = true;
    displayImpersonationModal: boolean = false;
    hideImpersonationModal: boolean = true;

    currentUserError: boolean = false;
    isCurrentUserLoading = computed(() => this.currentUserService.isCurrentUserLoading());

    toasterPositions = ToasterPositionEnum;
    intervalId: number = 0;

    constructor(
        private layoutService: LayoutService,
        private currentUserService: CurrentUserService,
        private router: Router,
        private mixpanel: MixpanelService
    ) {
        this.mixpanel.init();

        const userToImpersonate = BrowserStorageHelper.getImpersonatedUser();
        if (userToImpersonate) {
            this.currentUserService.setUserToImpersonate(userToImpersonate);
        }

        this.currentUserService.currentUser$.subscribe(currentUser => {
            this.currentUserError = false;

            if (currentUser.isAdmin && this.currentUserService.getImpersonatedUser() === null) {
                const _this = this;
                this.intervalId = window.setInterval(function () {
                    if (BrowserStorageHelper.getImpersonatedUser() !== null) {
                        _this.displayImpersonationModal = true;
                        return;
                    }

                    if (_this.displayImpersonationModal && !BrowserStorageHelper.getImpersonatedUser()) {
                        _this.hideImpersonationModal = true;
                    }
                }, 5000);
            }
        });

        this.currentUserService.currentUserError$.subscribe(hasError => {
            this.currentUserError = hasError;
        });

        this.currentUserService.impersonatedUser$.subscribe(user => {
            if (user !== null) {
                clearInterval(this.intervalId);
            }
        });

        this.layoutService.isSidebarCollapsed$.subscribe((isCollapsed: boolean) => {
            this.isSidebarCollapsed = isCollapsed;
        });

        this.layoutService.openImpersonationModal$.subscribe(() => {
            this.displayImpersonationModal = true;
        });

        this.router.events
            .pipe(
                filter(evt => evt instanceof NavigationError),
                map(evt => evt as NavigationError)
            )
            .subscribe((evt: any) => {
                if (evt?.error?.message?.toLowerCase().indexOf('failed to fetch dynamically imported module') > -1) {
                    window.location.href = evt.url;
                }
            });
    }
}
